import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";

// Wraps a page's filter controls with consistent Apply / Reset actions.
export function FilterShell({ children, onApply, onReset, testId = "filter-bar" }) {
  return (
    <div
      data-testid={testId}
      className="rounded-xl border border-border bg-card p-4 shadow-soft"
    >
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end">
        <div className="grid flex-1 grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {children}
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            className="h-10"
            onClick={onReset}
            data-testid="reset-filters-button"
          >
            Reset
          </Button>
          <Button
            className="h-10 gap-2"
            onClick={onApply}
            data-testid="apply-filters-button"
          >
            <SlidersHorizontal className="h-4 w-4" />
            Apply Filters
          </Button>
        </div>
      </div>
    </div>
  );
}
